import type { RunState } from "../api/types";

const LABELS: Record<RunState, string> = {
  running: "Running",
  succeeded: "Succeeded",
  failed: "Failed",
  interrupted: "Interrupted",
};

// "interrupted" is deliberately its own tone — neither the green of a success nor the red of a
// reported failure, because nothing actually reported a result; see RunStatus.notice for why.
const TONES: Record<RunState, "pending" | "attention" | "ready"> = {
  running: "pending",
  succeeded: "ready",
  failed: "attention",
  interrupted: "attention",
};

interface RunStateBadgeProps {
  state: RunState;
}

export function RunStateBadge({ state }: RunStateBadgeProps): JSX.Element {
  return <span className={`badge badge--${TONES[state]}`}>{LABELS[state]}</span>;
}
